let hasVibration = false;

if (
  typeof window !== 'undefined' &&
  typeof window.navigator.vibrate === 'function'
) {
  hasVibration = true;
}

export const buttonPress = event => {
  if (hasVibration && event && event.type === 'click') {
    window.navigator.vibrate(100);
  }
};

export default {
  buttonPress,
};



// WEBPACK FOOTER //
// ./src/services/vibration.js